import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { comoLlegar } from '../lib/mapas';
import { DESCUENTOS, DESCUENTOS_SRCSET } from '../lib/imagenes';
import Navbar from '../components/Navbar';
import { ToastContainer } from '../components/Toast';
import { useToast } from '../hooks/useToast';
import '../styles/Regalos.css';
import '../styles/Extras.css';

// Cupido Descuentos: locales de San Juan con descuento para citas. Los patrocinados son "lugar recomendado".
// Los locales cargan sus descuentos desde su panel (/comercio) y validan ahí los códigos.
const etiqueta = (c) => c === 'Alojamiento' ? '🔒 Alojamiento' : c;
export default function DescuentosPage() {
  const { toasts, success, error } = useToast();
  const [lista, setLista] = useState(null);
  const [categoria, setCategoria] = useState('');
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.descuentos().then(d => setLista(d.descuentos || [])).catch(e => { setLista([]); error(e.message || 'No se pudieron cargar los descuentos.'); });
  }, [error]);

  const categorias = [...new Set((lista || []).map(d => d.categoria))];
  const visibles = (lista || []).filter(d => !categoria || d.categoria === categoria);

  const obtener = async (id) => {
    setBusy(id);
    try {
      const { codigo } = await api.codigoDescuento(id);
      setLista(l => l.map(d => d.id === id ? { ...d, codigo } : d));
      success('🎟️ ¡Código listo! Mostralo en el local.');
    } catch (e) { error(e.message || 'No se pudo obtener el código.'); }
    finally { setBusy(null); }
  };

  return (
    <div className="regalos-page">
      <Navbar />
      <ToastContainer toasts={toasts} />
      <div className="regalos-container container">
        <div className="descuentos-header">
          <img src={DESCUENTOS} srcSet={DESCUENTOS_SRCSET} sizes="(max-width: 600px) 80px, 110px" alt="" className="descuentos-logo" />
          <h1 className="regalos-title" style={{ marginBottom: 8 }}>Cupido Descuentos</h1>
        </div>
        <p className="regalos-sub" style={{ marginBottom: 20 }}>
          Bares, cafés, restaurantes y más lugares de San Juan con descuento para tus citas. Tocá "Obtener código" y mostralo al pagar.
          Con Premium podés elegirlos como lugar de tu 🛡️ Cita segura.
        </p>

        {categorias.length > 1 && (
          <div className="descuentos-filtros">
            <button className={`afinidad-opcion ${!categoria ? 'activa' : ''}`} onClick={() => setCategoria('')}>Todos</button>
            {categorias.map(c => (
              <button key={c} className={`afinidad-opcion ${categoria === c ? 'activa' : ''}`} onClick={() => setCategoria(c)}>{etiqueta(c)}</button>
            ))}
          </div>
        )}

        {!lista ? <p className="regalos-empty">Cargando…</p>
          : visibles.length === 0 ? <p className="regalos-empty">Muy pronto vas a encontrar acá descuentos para tus citas. 🧉</p>
          : (
            <div className="descuentos-grid">
              {visibles.map(d => (
                <div key={d.id} className={`descuento-card ${d.patrocinado ? 'descuento-card--patrocinado' : ''}`}>
                  {d.patrocinado && <span className="descuento-recomendado">{d.categoria === 'Alojamiento' ? '⭐ Destacado' : '📍 Lugar recomendado para la primera cita'}</span>}
                  <div className="descuento-head">
                    <div className="descuento-local">
                      {d.logo_path && <img src={d.logo_path} alt="" className="descuento-logo" loading="lazy" />}
                      <div>
                        <div className="descuento-nombre">{d.nombre_local}</div>
                        <div className="descuento-cat">{etiqueta(d.categoria)}</div>
                      </div>
                    </div>
                    <div className="descuento-valor">{d.descuento}</div>
                  </div>
                  {d.descripcion && <p className="descuento-desc">{d.descripcion}</p>}
                  {d.direccion && <p className="descuento-dir">📍 {d.direccion}</p>}
                  {d.condiciones && <p className="descuento-cond">{d.condiciones}</p>}
                  <div className="descuento-acciones">
                    {d.codigo
                      ? <span className="descuento-codigo">{d.codigo}</span>
                      : <button className="btn btn-primary btn-sm" disabled={busy === d.id} onClick={() => obtener(d.id)}>{busy === d.id ? 'Generando…' : '🎟️ Obtener código'}</button>}
                    {d.direccion && (
                      <a className="btn btn-outline btn-sm" href={comoLlegar(d.direccion, d.nombre_local)} target="_blank" rel="noopener noreferrer">🗺️ Cómo llegar</a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
}
